// This file is auto generated using CMS based event tracking.
// Do not modify this file manually!
import { BaseTrackingContext } from '@goeuro/app/client/tracking-provider/src/cms/lib/BaseTrackingContext';

/* Properties block */
export type WasabiContextProperties = {
  experiment_id: string;
  variation_name: string;
  is_active: boolean;
};

/* Context definition block */
const schema = 'iglu:com.goeuro/wasabi_context/jsonschema/3-0-0';
export const wasabiContextName = 'wasabi_context';
export class WasabiContext extends BaseTrackingContext<WasabiContextProperties> {
  constructor(properties: WasabiContextProperties) {
    super(wasabiContextName, schema, properties);
  }
}
